export default __webpack_public_path__ + "static/media/person-group.62ba72bd.svg";